import { defineMessages } from "react-intl";
export var messages = defineMessages({
  collapsedButtonLabel: {
    id: "jutro-router.RightSideBar.collapsedButtonLabel",
    defaultMessage: "Expand menu"
  },
  expandedButtonLabel: {
    id: "jutro-router.RightSideBar.expandedButtonLabel",
    defaultMessage: "Collapse menu"
  }
});